<form #form="ngForm"
      novalidate
      [afterContentInit]="registerForm.bind(this, form)">
  <div class="form-group" *ngIf="personType === PAYMENT_PERSON_TYPES.COMPANY">
    <label class="fw-bold label-xl-to-md">{{'common.companyName' | translate}}</label>
    <input class="form-control"
           name="company_name"
           *ngIf="!useCompanySearcher"
           [(ngModel)]="info.userCompanyName"
           [maxlength]="64"
           placeholder="{{'common.companyName' | translate}}..."
           required>

    <company-searcher
        class="d-block"
        *ngIf="useCompanySearcher && !info.userCompanyName"
        [compact]="true"
        [allowToChangeCountry]="false"
        [bakeryId]="bakeryId"
        [countryCode]="countryCode"
        [allowEhk]="true"
        [selectedItem]="{'name': info.userCompanyName}"
        [showCompanySearcherLabel]="false"
        [allowToChangeCompany]="allowToEditCompany"
        (onCompanyFound)="companySelected($event)"
    ></company-searcher>

    <div *ngIf="useCompanySearcher && info.userCompanyName">
      <div class="org-name-org-number">
        <input class="form-control"
               type="text"
               disabled
               [value]="info.userCompanyName"/>

        <div class="invoice-info-org-number font-md">
          {{ info.invoiceCompanyOrgNumber }}
        </div>
      </div>

      <div class="text-end">
        <button type="button" class="btn btn-link pt-1 pe-0"
                [disabled]="!allowToEditCompany"
                (click)="clearCompany()">
          {{ 'orderProcess.payment.userInvoiceInfo.changeCompany' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="form-group" *ngIf="askUserName">
    <label class="fw-bold label-xl-to-md">{{'common.name' | translate}}</label>
    <input class="form-control"
           name="full_name"
           [(ngModel)]="info.userName"
           [maxlength]="120"
           placeholder="{{'orderProcess.payment.contactForm.yourName' | translate}}..."
           required>
  </div>

  <div class="form-group" *ngIf="askEmail">
    <label class="fw-bold label-xl-to-md">{{'common.emailAddress' | translate}}</label>
    <input class="form-control"
           name="email"
           [(ngModel)]="info.userEmail"
           [maxlength]="128"
           [pattern]="EMAIL_PATTERN"
           placeholder="{{'orderProcess.payment.contactForm.yourEmail' | translate}}..."
           required/>

    <ui-email-misspelled
      class="d-block mt-1"
      [email]="info.userEmail"
    ></ui-email-misspelled>
  </div>

  <div class="row" *ngIf="showPhone">
    <div class="col-lg-8">
      <ui-i18n-phone-input
        *libphonenumber
        maxlength="32"
        name="phone"
        [required]="true"
        [defaultCountryCode]="countryCode"
        [placeholder]="('orderProcess.payment.contactForm.yourMobile' | translate) + '...'"
        [(ngModel)]="info.userPhone"
      ></ui-i18n-phone-input>

      <small *ngIf="showSmsInfo" class="d-block text-muted phone-number-note"
             [translate]="'orderProcess.payment.phoneNumberNote'">
        We will send your order confirmation per sms (free)
      </small>
    </div>
  </div>

  <div class="form-group mt-3 position-relative" *ngIf="askForReferenceField">
    <label class="label-xl-to-md fw-bold">
      {{'orderProcess.payment.reference.title' | translate}}
      <small class="fw-normal">({{'common.optional' | translate}})</small>
    </label>
    <ui-input-with-tooltip
      [tooltipText]="'orderProcess.payment.reference.tooltipText' | translate">
      <input class="form-control position-relative"
             [name]="'reference'"
             [maxlength]="128"
             [placeholder]="'orderProcess.payment.reference.placeholder' | translate"
             [(ngModel)]="info.reference"/>
    </ui-input-with-tooltip>
  </div>
</form>
